import {FormEvent} from "react";
import {connect} from "react-redux";
import {Card, CardText, CardActions} from "material-ui/Card";
import TextField from "material-ui/TextField";
import FlatButton from "material-ui/FlatButton";
import {colors} from "material-ui/styles";

import {RootState} from "src/reducers";
import {Text} from "src/components/translation";

import {
  loginFormSubmitted,
  usernameChanged,
  passwordChanged,
  authProviderChanged,
} from "./Login.actions";


const styles = {
  container: {
    width: 350,
    margin: '200px auto 0',
  },

  error: {
    color: colors.red500,
    lineHeight: '36px',
    height: 36,
    verticalAlign: 'middle',
  },
};


const Login = connect(
  (state: RootState) => {
    const {username, password, authProvider} = state.routes.login;
    const {status, loginError} = state.iceClient;
    const {user} = state;

    return {authProvider, username, password, status, loginError, user};
  },
  {
    onUsernameChange: (e: any, value: string) => usernameChanged(value),
    onPasswordChange: (e: any, value: string) => passwordChanged(value),
    onAuthProviderChange: (e: any, value: string) =>
      authProviderChanged(value),
    onSubmit(e: FormEvent<any>) {
      e.preventDefault();
      return loginFormSubmitted();
    },
  },
)(({
  authProvider,
  username,
  password,
  status,
  loginError,
  user,

  onAuthProviderChange,
  onUsernameChange,
  onPasswordChange,
  onSubmit,
}) => {
  const isLoggingIn = status === 'logging-in' ||
                      (status === 'logged-in' && user == null);

  const isSubmitDisabled = isLoggingIn || !username ||
                           !password || !authProvider;

  return <Card zDepth={4} style={styles.container}>
    <form onSubmit={onSubmit}>
      <CardText>
        <TextField fullWidth hintText={<Text>Domain</Text>}
                   disabled={isLoggingIn}
                   autoFocus={!authProvider}
                   value={authProvider} onChange={onAuthProviderChange}/>

        <TextField fullWidth hintText={<Text>Username</Text>}
                   disabled={isLoggingIn}
                   autoFocus={!!authProvider}
                   value={username} onChange={onUsernameChange}/>

        <TextField fullWidth hintText={<Text>Password</Text>}
                   type="password"
                   disabled={isLoggingIn}
                   value={password} onChange={onPasswordChange}/>
      </CardText>

      <CardActions>
        <FlatButton primary
                    label={<Text>Log In</Text>}
                    type="submit"
                    disabled={isSubmitDisabled}/>

        {loginError && <span style={styles.error}>
          {loginError === 'credentials' && <Text>Invalid credentials</Text>}
          {loginError === 'unknown' && <Text>Error</Text>}
        </span>}
      </CardActions>
    </form>
  </Card>;
});


export default Login;



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/routes/login/Login.tsx